import { Alert, Box, Button, Typography } from '@mui/material';
import type { ImportSession } from '@timetable/types';

const STEP_LABELS: Record<number, string> = {
  1: 'Academic Year',
  2: 'Master Data',
  3: 'Include Timetable?',
  4: 'Timetable Format',
  5: 'Upload Timetable',
  6: 'Confirm & Import',
};

interface SessionResumeBannerProps {
  session: ImportSession;
  startedByName?: string;
  updatedByName?: string;
  onResume: () => void;
  onStartOver: () => void;
}

export function SessionResumeBanner({
  session,
  startedByName,
  updatedByName,
  onResume,
  onStartOver,
}: SessionResumeBannerProps) {
  const stepLabel = STEP_LABELS[session.current_step] ?? `Step ${session.current_step}`;

  return (
    <Alert
      severity="info"
      sx={{ mb: 3 }}
      action={
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Button size="small" variant="contained" onClick={onResume}>
            Resume
          </Button>
          <Button size="small" variant="outlined" color="inherit" onClick={onStartOver}>
            Start Over
          </Button>
        </Box>
      }
    >
      <Typography variant="body2" fontWeight="medium">
        You have an in-progress import session
      </Typography>
      <Typography variant="body2">
        Last step: {stepLabel}
        {startedByName && ` · Started by ${startedByName}`}
        {updatedByName && ` · Last updated by ${updatedByName}`}
      </Typography>
    </Alert>
  );
}
